import React from "react";
import { useTranslation } from "react-i18next";

const PricingHeader = ({ currency }: { currency: string }) => {
  const { t } = useTranslation();
  
  return (
    <div className="text-center space-y-4">
      <h2 className="text-4xl font-bold tracking-tight">
        {t('pricing.chooseYourPlan')}
      </h2>
      <p className="text-muted-foreground">
        {t('pricing.selectPlanDescription')}
      </p>
    </div>
  );
};

export default PricingHeader;
